(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-configurator"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-configurator')) {
    customElements.define('product-configurator', class ProductConfigurator extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') {
          return;
        }

        this.dataset.initialized = 'true';
        this.dialog = this.querySelector('[data-configurator-dialog]');
        this.trigger = this.querySelector('[data-configurator-trigger]');
        this.error = this.querySelector('[data-configurator-error]');
        this.optionGroups = this.querySelector('[data-option-groups]');
        this.summary = this.querySelector('[data-configuration-summary]');
        this.validationStatus = this.querySelector('[data-validation-status]');
        this.useButton = this.querySelector('[data-use-configuration]');
        this.viewerStatus = this.querySelector('[data-viewer-status]');
        this.stage = this.querySelector('.product-configurator__stage');
        this.modelContainer = this.querySelector('[data-model-media-id]');
        this.modelViewer = this.querySelector('model-viewer');
        this.translations = this.parseJson('[data-configurator-translations]');
        this.model = this.parseJson('[data-configuration-model]');
        this.layeredPreview = this.querySelector('[data-layered-preview]');
        this.layeredCanvas = this.querySelector('[data-layered-canvas]');
        this.layeredFelt = this.querySelector('[data-layered-felt]');
        this.layeredFinishLayers = [...this.querySelectorAll('[data-layered-finish]')];
        this.layeredSight = this.querySelector('[data-layered-sight]');
        this.layeredSightLabel = this.querySelector('[data-layered-sight-label]');
        this.state = {};
        this.viewerReady = false;
        this.viewerFailed = false;
        this.viewerPreparing = false;
        this.visualUpdateToken = 0;
        this.textureCache = new Map();
        this.layeredAssetCache = new Map();
        this.layeredZoom = 1;
        this.activeFinishLayer = this.layeredFinishLayers[0] || null;
        this.catalogErrors = this.validateCatalog();

        this.bindDialog();
        this.bindThumbnails();
        this.bindModelViewer();
        this.bindLayeredPreview();

        if (this.catalogErrors.length > 0) {
          this.showError(this.translations.unavailable);
          this.useButton.disabled = true;
          return;
        }

        this.state = this.restoreState();
        this.renderOptions();
        this.update();

        if (this.modelViewer?.loaded) {
          void this.prepareModelViewer();
        }

        if (this.model.viewer?.mode === 'layered_preview') {
          void this.prepareLayeredPreview();
        }
      }

      parseJson(selector) {
        const script = this.querySelector(selector);

        if (!script) {
          return {};
        }

        try {
          return JSON.parse(script.textContent);
        } catch (error) {
          return {};
        }
      }

      validateCatalog() {
        const errors = [];
        const eligibility = this.model.eligibility || {};
        const options = Array.isArray(this.model.options) ? this.model.options : [];

        if (this.model.schemaVersion !== '1.1' || this.model.catalog?.optionInheritance !== 'none' || this.model.catalog?.unmappedOptionsHidden !== true) {
          errors.push('invalid_catalog_policy');
        }

        if (eligibility.mode !== 'exact_product' || String(eligibility.shopifyProductId) !== this.dataset.productId || eligibility.handle !== this.dataset.productHandle || eligibility.templateSuffix !== this.dataset.productTemplate || eligibility.validated !== true) {
          errors.push('product_mismatch');
        }

        if (options.length === 0) {
          errors.push('empty_catalog');
        }

        const optionIds = new Set();
        const optionValues = new Map();

        options.forEach((option) => {
          if (!option.id || !option.sourceOptionId || optionIds.has(option.id) || !['visual', 'quote_only'].includes(option.kind) || !Array.isArray(option.values) || option.values.length === 0) {
            errors.push(`invalid_option:${option.id || 'unknown'}`);
            return;
          }

          optionIds.add(option.id);
          const valueIds = new Set();
          optionValues.set(option.id, valueIds);

          option.values.forEach((value) => {
            if (!value.id || !value.sourceValueId || valueIds.has(value.id) || value.eligible !== true) {
              errors.push(`invalid_value:${option.id}:${value.id || 'unknown'}`);
            }

            valueIds.add(value.id);
          });

          const defaultValue = this.model.defaults?.[option.id];

          if (option.requiresExplicitSelection === true) {
            if (defaultValue !== null) {
              errors.push(`invalid_explicit_selection_default:${option.id}`);
            }
          } else if (!valueIds.has(defaultValue)) {
            errors.push(`invalid_default:${option.id}`);
          }
        });

        const viewer = this.model.viewer || {};
        const visualOptions = options.filter((option) => option.kind === 'visual');
        const quoteOnlyOptions = options.filter((option) => option.kind === 'quote_only');
        const imageEffects = new Set(['selection_label', 'verified_swatch']);
        const layeredEffects = new Set(['layer_image', 'surface_color', 'detail_image']);
        const layeredKinds = new Set(['image', 'surface', 'detail']);
        const modelEffects = new Set(['material_color', 'material_texture', 'material_variant', 'visibility_variant', 'emissive_state']);
        const isNonEmptyString = (value) => typeof value === 'string' && value.trim().length > 0;
        const isHexColor = (value) => typeof value === 'string' && /^#[0-9a-f]{6}$/i.test(value);
        const isHttpsUrl = (value) => {
          try {
            return new URL(value, window.location.origin).protocol === 'https:';
          } catch (error) {
            return false;
          }
        };

        if (viewer.mode === 'image_preview') {
          if (viewer.hasShopifyModel !== false || viewer.mappingStatus !== 'representative_media_only' || this.modelViewer) {
            errors.push('invalid_image_viewer');
          }

          visualOptions.forEach((option) => {
            if (!imageEffects.has(option.viewerEffect) || option.values.some((value) => value.visualMapping != null)) {
              errors.push(`invalid_image_effect:${option.id}`);
            }
          });
        } else if (viewer.mode === 'layered_preview') {
          const layers = Array.isArray(viewer.layers) ? viewer.layers : [];
          const layerMap = new Map();
          const layerOwners = new Map();

          if (viewer.hasShopifyModel !== false || viewer.mappingStatus !== 'verified_source_layers' || viewer.privatePreviewOnly !== true || !isNonEmptyString(viewer.sourceAttribution) || !isNonEmptyString(viewer.sourceManifest) || this.modelViewer) {
            errors.push('invalid_layered_viewer');
          }

          if (viewer.interaction?.zoom !== true || viewer.interaction?.orbit !== false || viewer.transition?.preloadVisualAssets !== true || viewer.transition?.preserveStage !== true || viewer.transition?.reloadFullImage !== false) {
            errors.push('invalid_layered_interaction');
          }

          layers.forEach((layer) => {
            if (!isNonEmptyString(layer.id) || !layeredKinds.has(layer.kind) || layer.verified !== true || layerMap.has(layer.id)) {
              errors.push(`invalid_layer:${layer.id || 'unknown'}`);
              return;
            }

            layerMap.set(layer.id, layer);
          });

          if (layerMap.size === 0 || !this.layeredPreview) {
            errors.push('empty_layered_viewer');
          }

          visualOptions.forEach((option) => {
            const optionLayerIds = new Set();

            if (!layeredEffects.has(option.viewerEffect)) {
              errors.push(`invalid_layered_effect:${option.id}`);
            }

            option.values.forEach((value) => {
              const mapping = value.visualMapping;

              if (!mapping || mapping.verified !== true || mapping.effect !== option.viewerEffect || !layerMap.has(mapping.layerId)) {
                errors.push(`invalid_layered_mapping:${option.id}:${value.id}`);
                return;
              }

              optionLayerIds.add(mapping.layerId);

              if (['layer_image', 'detail_image'].includes(mapping.effect) && (!isHttpsUrl(mapping.assetUrl) || !isNonEmptyString(mapping.assetId))) {
                errors.push(`invalid_layered_asset:${option.id}:${value.id}`);
              }

              if (mapping.effect === 'surface_color' && (!isHexColor(mapping.color) || mapping.color.toLowerCase() !== value.color?.toLowerCase())) {
                errors.push(`invalid_layered_color:${option.id}:${value.id}`);
              }
            });

            if (optionLayerIds.size !== 1) {
              errors.push(`invalid_layer_count:${option.id}`);
            }

            optionLayerIds.forEach((layerId) => {
              if (layerOwners.has(layerId)) {
                errors.push(`duplicate_layer_owner:${option.id}:${layerId}`);
              } else {
                layerOwners.set(layerId, option.id);
              }
            });
          });
        } else if (viewer.mode === 'shopify_model') {
          const expectedMediaId = String(viewer.shopifyModelMediaId || '');
          const actualMediaId = this.modelContainer?.dataset.modelMediaId || '';
          const slots = Array.isArray(viewer.materialSlots) ? viewer.materialSlots : [];
          const slotMap = new Map();
          const slotOwners = new Map();
          let materialVariantOptions = 0;

          if (viewer.contractVersion !== '1.0' || viewer.hasShopifyModel !== true || !this.modelViewer || expectedMediaId !== actualMediaId || !Number.isSafeInteger(viewer.shopifyModelMediaId) || viewer.shopifyModelMediaId <= 0) {
            errors.push('invalid_model_identity');
          }

          if (viewer.mappingStatus !== 'verified_material_slots' || viewer.asset?.verified !== true || !isNonEmptyString(viewer.asset?.id) || !isNonEmptyString(viewer.asset?.version) || !isNonEmptyString(viewer.asset?.sourceId)) {
            errors.push('invalid_model_provenance');
          }

          if (viewer.interaction?.orbit !== true || viewer.interaction?.zoom !== true || viewer.transition?.preserveCamera !== true || viewer.transition?.preloadVisualAssets !== true || viewer.transition?.reloadModel !== false) {
            errors.push('invalid_model_interaction');
          }

          slots.forEach((slot) => {
            if (!isNonEmptyString(slot.id) || !isNonEmptyString(slot.materialName) || !['surface', 'component', 'lighting'].includes(slot.kind) || slot.verified !== true || slotMap.has(slot.id)) {
              errors.push(`invalid_material_slot:${slot.id || 'unknown'}`);
              return;
            }

            slotMap.set(slot.id, slot);
          });

          if (slotMap.size === 0) {
            errors.push('empty_material_slots');
          }

          visualOptions.forEach((option) => {
            const optionSlotIds = new Set();
            if (!modelEffects.has(option.viewerEffect)) {
              errors.push(`invalid_model_effect:${option.id}`);
            }

            if (option.viewerEffect === 'material_variant') {
              materialVariantOptions += 1;
            }

            option.values.forEach((value) => {
              const mapping = value.visualMapping;
              const slot = slotMap.get(mapping?.slotId);

              if (!mapping || mapping.verified !== true || mapping.effect !== option.viewerEffect || !slot) {
                errors.push(`invalid_visual_mapping:${option.id}:${value.id}`);
                return;
              }

              optionSlotIds.add(mapping.slotId);

              if (mapping.effect === 'material_color' && !isHexColor(mapping.color)) {
                errors.push(`invalid_material_color:${option.id}:${value.id}`);
              }

              if (mapping.effect === 'material_texture' && (!isHttpsUrl(mapping.textureUrl) || !isNonEmptyString(mapping.textureAssetId))) {
                errors.push(`invalid_material_texture:${option.id}:${value.id}`);
              }

              if (mapping.effect === 'material_variant' && !isNonEmptyString(mapping.variantName)) {
                errors.push(`invalid_material_variant:${option.id}:${value.id}`);
              }

              if (mapping.effect === 'visibility_variant') {
                const controlled = Array.isArray(slot.controlledMaterialNames) ? slot.controlledMaterialNames : [];
                const visible = Array.isArray(mapping.visibleMaterialNames) ? mapping.visibleMaterialNames : [];

                if (controlled.length === 0 || visible.length === 0 || visible.some((name) => !controlled.includes(name))) {
                  errors.push(`invalid_visibility_variant:${option.id}:${value.id}`);
                }
              }

              if (mapping.effect === 'emissive_state' && (!isHexColor(mapping.color) || typeof mapping.intensity !== 'number' || mapping.intensity < 0 || slot.kind !== 'lighting')) {
                errors.push(`invalid_emissive_state:${option.id}:${value.id}`);
              }
            });

            if (optionSlotIds.size !== 1) {
              errors.push(`invalid_option_slot_count:${option.id}`);
            }

            optionSlotIds.forEach((slotId) => {
              if (slotOwners.has(slotId)) {
                errors.push(`duplicate_slot_owner:${option.id}:${slotId}`);
              } else {
                slotOwners.set(slotId, option.id);
              }
            });
          });

          if (materialVariantOptions > 1) {
            errors.push('multiple_global_material_variants');
          }
        } else {
          errors.push('invalid_viewer_mode');
        }

        quoteOnlyOptions.forEach((option) => {
          if (option.viewerEffect !== 'none' || option.values.some((value) => value.visualMapping != null)) {
            errors.push(`invalid_quote_only_effect:${option.id}`);
          }
        });

        const rules = this.model.compatibilityRules;

        if (!Array.isArray(rules)) {
          errors.push('invalid_compatibility_rules');
        } else {
          rules.forEach((rule, index) => {
            if (rule.when && !optionValues.get(rule.when.optionId)?.has(rule.when.valueId)) {
              errors.push(`invalid_rule_condition:${index}`);
            }

            if (!Array.isArray(rule.disable)) {
              errors.push(`invalid_rule_targets:${index}`);
              return;
            }

            rule.disable.forEach((target) => {
              if (!Array.isArray(target.valueIds) || target.valueIds.some((valueId) => !optionValues.get(target.optionId)?.has(valueId))) {
                errors.push(`invalid_rule_target:${index}:${target.optionId || 'unknown'}`);
              }
            });
          });
        }

        return errors;
      }

      bindDialog() {
        this.trigger?.addEventListener('click', (event) => {
          event.preventDefault();

          if (!this.dialog?.showModal) {
            window.location.hash = this.dataset.quotePanelId;
            return;
          }

          this.dialog.showModal();
          requestAnimationFrame(() => this.querySelector('input:not(:disabled)')?.focus());
        });

        this.dialog?.addEventListener('click', (event) => {
          if (event.target === this.dialog) {
            this.dialog.close();
          }
        });

        this.dialog?.addEventListener('close', () => {
          const body = this.querySelector('.product-configurator__body--model');
          const mobileToggle = this.querySelector('[data-mobile-view-toggle]');
          body?.classList.remove('product-configurator__body--viewer-expanded');
          mobileToggle?.setAttribute('aria-pressed', 'false');
          mobileToggle?.setAttribute('aria-label', this.translations.maximizeView);
          mobileToggle?.setAttribute('title', this.translations.maximizeView);
          this.trigger?.focus();
        });
        this.useButton?.addEventListener('click', () => this.useConfiguration());
      }

      bindThumbnails() {
        this.querySelectorAll('[data-preview-source]').forEach((button) => {
          button.addEventListener('click', () => {
            const image = this.querySelector('.product-configurator__image');

            if (!image) {
              return;
            }

            image.src = button.dataset.previewSource;
            image.removeAttribute('srcset');
            this.querySelectorAll('[data-preview-source]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
          });
        });
      }

      bindLayeredPreview() {
        if (this.model.viewer?.mode !== 'layered_preview' || !this.layeredPreview) {
          return;
        }

        const zoomOut = this.querySelector('[data-viewer-zoom-out]');
        const reset = this.querySelector('[data-viewer-reset]');
        const zoomIn = this.querySelector('[data-viewer-zoom-in]');
        const mobileToggle = this.querySelector('[data-mobile-view-toggle]');

        zoomOut?.addEventListener('click', () => this.setLayeredZoom(this.layeredZoom - 0.15));
        reset?.addEventListener('click', () => this.setLayeredZoom(1));
        zoomIn?.addEventListener('click', () => this.setLayeredZoom(this.layeredZoom + 0.15));
        mobileToggle?.addEventListener('click', () => {
          const body = this.querySelector('.product-configurator__body--model');
          const expanded = body?.classList.toggle('product-configurator__body--viewer-expanded') === true;
          mobileToggle.setAttribute('aria-pressed', String(expanded));
          mobileToggle.setAttribute('aria-label', expanded ? this.translations.showOptions : this.translations.maximizeView);
          mobileToggle.setAttribute('title', expanded ? this.translations.showOptions : this.translations.maximizeView);
        });
      }

      setLayeredZoom(value) {
        if (!this.viewerReady || !this.layeredCanvas) return;

        this.layeredZoom = Math.min(1.75, Math.max(1, Number(value.toFixed(2))));
        this.layeredCanvas.style.setProperty('--builder-preview-scale', String(this.layeredZoom));
        const zoomOut = this.querySelector('[data-viewer-zoom-out]');
        const zoomIn = this.querySelector('[data-viewer-zoom-in]');
        if (zoomOut) zoomOut.disabled = this.layeredZoom <= 1;
        if (zoomIn) zoomIn.disabled = this.layeredZoom >= 1.75;
      }

      async prepareLayeredPreview() {
        if (!this.layeredPreview || this.viewerPreparing || this.viewerReady || this.viewerFailed || this.catalogErrors.length > 0) {
          return;
        }

        this.viewerPreparing = true;
        this.stage?.setAttribute('aria-busy', 'true');
        this.viewerStatus.textContent = this.translations.previewLoading;

        try {
          const urls = new Set();
          this.model.options.forEach((option) => {
            option.values.forEach((value) => {
              if (['layer_image', 'detail_image'].includes(value.visualMapping?.effect)) {
                urls.add(value.visualMapping.assetUrl);
              }
            });
          });

          await Promise.all([...urls].map((url) => this.preloadLayeredAsset(url)));
          this.viewerReady = true;
          this.viewerPreparing = false;
          this.stage?.setAttribute('aria-busy', 'false');
          this.layeredPreview.setAttribute('aria-busy', 'false');
          this.layeredPreview.dataset.ready = 'true';
          this.viewerStatus.textContent = this.translations.previewReady;
          this.querySelectorAll('[data-viewer-reset], [data-viewer-zoom-in]').forEach((button) => {
            button.disabled = false;
          });
          this.setLayeredZoom(1);
          this.update();
        } catch (error) {
          this.viewerPreparing = false;
          this.failLayeredPreview(this.translations.previewMappingError);
        }
      }

      preloadLayeredAsset(url) {
        if (!this.layeredAssetCache.has(url)) {
          this.layeredAssetCache.set(url, new Promise((resolve, reject) => {
            const image = new Image();
            image.decoding = 'async';
            image.onload = () => resolve(image);
            image.onerror = () => reject(new Error(`Unable to load ${url}`));
            image.src = url;
          }));
        }

        return this.layeredAssetCache.get(url);
      }

      failLayeredPreview(message) {
        if (this.viewerFailed) return;

        this.viewerFailed = true;
        this.viewerReady = false;
        this.visualUpdateToken += 1;
        this.stage?.setAttribute('aria-busy', 'false');
        this.layeredPreview?.setAttribute('aria-busy', 'false');
        this.viewerStatus.textContent = message;
        this.querySelectorAll('[data-viewer-zoom-out], [data-viewer-reset], [data-viewer-zoom-in]').forEach((button) => {
          button.disabled = true;
        });
        this.showError(message);
        this.useButton.disabled = true;
      }

      applyLayeredMappings() {
        if (this.model.viewer?.mode !== 'layered_preview' || !this.viewerReady || this.viewerFailed) {
          return;
        }

        const updateToken = ++this.visualUpdateToken;

        for (const option of this.model.options.filter((item) => item.kind === 'visual')) {
          const value = this.selectedValue(option);
          const mapping = value?.visualMapping;

          if (!mapping || updateToken !== this.visualUpdateToken) return;

          if (mapping.effect === 'surface_color') {
            this.layeredFelt?.style.setProperty('--builder-felt-color', mapping.color);
          } else if (mapping.effect === 'layer_image') {
            const currentSource = this.activeFinishLayer?.getAttribute('src');

            if (currentSource !== mapping.assetUrl) {
              const nextLayer = this.layeredFinishLayers.find((layer) => layer !== this.activeFinishLayer) || this.activeFinishLayer;
              nextLayer.setAttribute('src', mapping.assetUrl);
              nextLayer.classList.add('is-active');
              this.activeFinishLayer?.classList.remove('is-active');
              this.activeFinishLayer = nextLayer;
            }
          } else if (mapping.effect === 'detail_image') {
            if (this.layeredSight?.getAttribute('src') !== mapping.assetUrl) {
              this.layeredSight?.setAttribute('src', mapping.assetUrl);
            }
            if (this.layeredSight) this.layeredSight.alt = `${option.label}: ${value.label}`;
            if (this.layeredSightLabel) this.layeredSightLabel.textContent = value.label;
          }
        }
      }

      bindModelViewer() {
        const zoomOut = this.querySelector('[data-viewer-zoom-out]');
        const reset = this.querySelector('[data-viewer-reset]');
        const zoomIn = this.querySelector('[data-viewer-zoom-in]');
        const mobileToggle = this.querySelector('[data-mobile-view-toggle]');

        if (!this.modelViewer) {
          return;
        }

        this.initialCamera = {
          orbit: this.modelViewer.getAttribute('camera-orbit'),
          target: this.modelViewer.getAttribute('camera-target'),
          fieldOfView: this.modelViewer.getAttribute('field-of-view')
        };

        [zoomOut, reset, zoomIn].forEach((button) => {
          if (button) button.disabled = true;
        });

        zoomOut?.addEventListener('click', () => {
          if (this.viewerReady) this.modelViewer.zoom(-1);
        });

        zoomIn?.addEventListener('click', () => {
          if (this.viewerReady) this.modelViewer.zoom(1);
        });

        reset?.addEventListener('click', () => {
          if (!this.viewerReady) return;

          this.restoreCameraAttribute('camera-orbit', this.initialCamera.orbit);
          this.restoreCameraAttribute('camera-target', this.initialCamera.target);
          this.restoreCameraAttribute('field-of-view', this.initialCamera.fieldOfView);
          this.modelViewer.resetTurntableRotation?.(0);
        });

        mobileToggle?.addEventListener('click', () => {
          const body = this.querySelector('.product-configurator__body--model');
          const expanded = body?.classList.toggle('product-configurator__body--viewer-expanded') === true;
          mobileToggle.setAttribute('aria-pressed', String(expanded));
          mobileToggle.setAttribute('aria-label', expanded ? this.translations.showOptions : this.translations.maximizeView);
          mobileToggle.setAttribute('title', expanded ? this.translations.showOptions : this.translations.maximizeView);
        });

        this.viewerStatus.textContent = this.translations.modelLoading;
        this.modelViewer.addEventListener('load', () => void this.prepareModelViewer());
        this.modelViewer.addEventListener('error', () => this.failModelViewer(this.translations.modelLoadError));
      }

      restoreCameraAttribute(name, value) {
        if (value == null) {
          this.modelViewer.removeAttribute(name);
        } else {
          this.modelViewer.setAttribute(name, value);
        }
      }

      async prepareModelViewer() {
        if (!this.modelViewer || this.viewerPreparing || this.viewerReady || this.viewerFailed || this.catalogErrors.length > 0) {
          return;
        }

        this.viewerPreparing = true;
        this.stage?.setAttribute('aria-busy', 'true');
        this.viewerStatus.textContent = this.translations.modelLoading;

        try {
          const slots = this.model.viewer.materialSlots;
          const requiredNames = new Set();

          slots.forEach((slot) => {
            requiredNames.add(slot.materialName);
            (slot.controlledMaterialNames || []).forEach((name) => requiredNames.add(name));
          });

          for (const materialName of requiredNames) {
            const material = this.modelViewer.model?.getMaterialByName(materialName);

            if (!material) {
              throw new Error(`Missing verified material ${materialName}`);
            }

            if (typeof material.ensureLoaded === 'function') {
              await material.ensureLoaded();
            }
          }

          const effects = new Set(this.model.options.filter((option) => option.kind === 'visual').map((option) => option.viewerEffect));
          const firstSlotMaterial = this.modelViewer.model?.getMaterialByName(slots[0].materialName);

          if (effects.has('material_color') && typeof firstSlotMaterial?.pbrMetallicRoughness?.setBaseColorFactor !== 'function') {
            throw new Error('The viewer does not support material colors');
          }

          if (effects.has('material_texture') && (typeof this.modelViewer.createTexture !== 'function' || typeof firstSlotMaterial?.pbrMetallicRoughness?.baseColorTexture?.setTexture !== 'function')) {
            throw new Error('The viewer does not support material textures');
          }

          if (effects.has('visibility_variant') && (typeof firstSlotMaterial?.setAlphaMode !== 'function' || typeof firstSlotMaterial?.pbrMetallicRoughness?.setBaseColorFactor !== 'function')) {
            throw new Error('The viewer does not support component visibility');
          }

          if (effects.has('emissive_state') && (typeof firstSlotMaterial?.setEmissiveFactor !== 'function' || typeof firstSlotMaterial?.setEmissiveStrength !== 'function')) {
            throw new Error('The viewer does not support emissive states');
          }

          const availableVariants = new Set(this.modelViewer.availableVariants || []);
          this.model.options.filter((option) => option.viewerEffect === 'material_variant').forEach((option) => {
            option.values.forEach((value) => {
              if (!availableVariants.has(value.visualMapping.variantName)) {
                throw new Error(`Missing verified variant ${value.visualMapping.variantName}`);
              }
            });
          });

          await this.preloadViewerTextures();

          this.viewerReady = true;
          this.viewerPreparing = false;
          this.stage?.setAttribute('aria-busy', 'false');
          this.viewerStatus.textContent = this.translations.modelReady;
          this.querySelectorAll('[data-viewer-zoom-out], [data-viewer-reset], [data-viewer-zoom-in]').forEach((button) => {
            button.disabled = false;
          });
          this.update();
        } catch (error) {
          this.viewerPreparing = false;
          this.failModelViewer(this.translations.modelMappingError);
        }
      }

      async preloadViewerTextures() {
        const urls = new Set();

        this.model.options.forEach((option) => {
          option.values.forEach((value) => {
            if (value.visualMapping?.effect === 'material_texture') {
              urls.add(value.visualMapping.textureUrl);
            }
          });
        });

        for (const url of urls) {
          if (!this.textureCache.has(url)) {
            this.textureCache.set(url, this.modelViewer.createTexture(url));
          }
        }

        await Promise.all(this.textureCache.values());
      }

      failModelViewer(message) {
        if (this.viewerFailed) return;

        this.viewerFailed = true;
        this.viewerReady = false;
        this.visualUpdateToken += 1;
        this.stage?.setAttribute('aria-busy', 'false');
        this.viewerStatus.textContent = message;
        this.querySelectorAll('[data-viewer-zoom-out], [data-viewer-reset], [data-viewer-zoom-in]').forEach((button) => {
          button.disabled = true;
        });
        this.showError(message);
        this.useButton.disabled = true;

        if (this.currentConfiguration?.payload?.validation) {
          this.currentConfiguration.payload.validation.passed = false;
          this.currentConfiguration.payload.validation.errors = [...this.currentConfiguration.payload.validation.errors, 'viewer_unavailable'];
        }
      }

      async applyVisualMappings() {
        if (!this.modelViewer || !this.viewerReady || this.viewerFailed) {
          return;
        }

        const updateToken = ++this.visualUpdateToken;

        try {
          for (const option of this.model.options.filter((item) => item.kind === 'visual')) {
            const mapping = this.selectedValue(option)?.visualMapping;

            if (!mapping || updateToken !== this.visualUpdateToken) {
              return;
            }

            const slot = this.model.viewer.materialSlots.find((item) => item.id === mapping.slotId);
            const material = this.modelViewer.model.getMaterialByName(slot.materialName);

            if (mapping.effect === 'material_color') {
              material.pbrMetallicRoughness.setBaseColorFactor(mapping.color);
            } else if (mapping.effect === 'material_texture') {
              const texture = await this.textureCache.get(mapping.textureUrl);

              if (updateToken !== this.visualUpdateToken) return;
              material.pbrMetallicRoughness.baseColorTexture.setTexture(texture);
            } else if (mapping.effect === 'material_variant') {
              this.modelViewer.variantName = mapping.variantName;
            } else if (mapping.effect === 'visibility_variant') {
              const visibleNames = new Set(mapping.visibleMaterialNames);

              slot.controlledMaterialNames.forEach((materialName) => {
                const controlledMaterial = this.modelViewer.model.getMaterialByName(materialName);
                const baseColor = [...controlledMaterial.pbrMetallicRoughness.baseColorFactor];
                baseColor[3] = visibleNames.has(materialName) ? 1 : 0;
                controlledMaterial.setAlphaMode('BLEND');
                controlledMaterial.pbrMetallicRoughness.setBaseColorFactor(baseColor);
              });
            } else if (mapping.effect === 'emissive_state') {
              material.setEmissiveFactor(mapping.color);
              material.setEmissiveStrength?.(mapping.intensity);
            }
          }
        } catch (error) {
          if (updateToken === this.visualUpdateToken) {
            this.failModelViewer(this.translations.modelMappingError);
          }
        }
      }

      restoreState() {
        const nextState = { ...this.model.defaults };

        try {
          const stored = JSON.parse(sessionStorage.getItem(this.storageKey()));

          if (stored && typeof stored === 'object') {
            this.model.options.forEach((option) => {
              if (option.values.some((value) => value.id === stored[option.id] && value.eligible === true)) {
                nextState[option.id] = stored[option.id];
              }
            });
          }
        } catch (error) {
          return nextState;
        }

        return nextState;
      }

      storageKey() {
        return `badlands-builder:${this.dataset.productId}:${this.dataset.productHandle}:${this.model.catalogVersion}`;
      }

      committedKey() {
        return `${this.dataset.productId}:${this.dataset.productHandle}`;
      }

      renderOptions() {
        this.optionGroups.replaceChildren();

        this.model.options.forEach((option) => {
          const fieldset = document.createElement('fieldset');
          const legend = document.createElement('legend');
          const legendRow = document.createElement('span');
          const label = document.createElement('span');
          const kind = document.createElement('span');
          const choices = document.createElement('div');

          fieldset.className = 'product-configurator__option-group';
          legendRow.className = 'product-configurator__legend-row';
          label.className = 'bold';
          kind.className = 'product-configurator__kind';
          choices.className = `product-configurator__choices${option.presentation === 'swatch' ? ' product-configurator__choices--swatch' : ''}${option.presentation === 'image_grid' ? ' product-configurator__choices--image' : ''}`;
          label.textContent = option.label;
          kind.textContent = option.kind === 'visual' ? this.translations.visualGroup : this.translations.quoteOnlyGroup;
          legendRow.append(label, kind);
          legend.append(legendRow);
          fieldset.append(legend);

          if (option.description) {
            const description = document.createElement('p');
            description.className = 'text-xs text-subdued';
            description.textContent = option.description;
            fieldset.append(description);
          }

          option.values.forEach((value) => {
            const choice = document.createElement('div');
            const input = document.createElement('input');
            const choiceLabel = document.createElement('label');
            const choiceCopy = document.createElement('span');
            const text = document.createElement('span');
            const inputId = `${this.id}-${option.id}-${value.id}`;

            choice.className = 'product-configurator__choice';
            input.type = 'radio';
            input.id = inputId;
            input.name = `${this.id}-${option.id}`;
            input.value = value.id;
            input.dataset.optionId = option.id;
            input.checked = this.state[option.id] === value.id;
            input.disabled = value.eligible !== true;
            input.required = option.required === true;
            choiceLabel.htmlFor = inputId;
            choiceCopy.className = 'product-configurator__choice-copy';
            text.textContent = value.label;

            if (option.presentation === 'swatch' && value.color) {
              const swatch = document.createElement('span');
              swatch.className = 'product-configurator__swatch';
              swatch.style.setProperty('--swatch-color', value.color);
              choiceLabel.append(swatch);
            } else if (option.presentation === 'image_grid' && value.visualMapping?.assetUrl) {
              const image = document.createElement('img');
              image.className = 'product-configurator__choice-image';
              image.src = value.visualMapping.assetUrl;
              image.alt = '';
              image.loading = 'lazy';
              choiceLabel.append(image);
            }

            choiceCopy.append(text);

            if (value.description || value.quoteConfirmation === true) {
              const note = document.createElement('span');
              note.className = 'product-configurator__choice-note';
              note.textContent = value.description || this.translations.quoteConfirmation;
              choiceCopy.append(note);
            }

            choiceLabel.append(choiceCopy);
            choice.append(input, choiceLabel);
            choices.append(choice);

            input.addEventListener('change', () => {
              if (input.checked) {
                this.state[option.id] = value.id;
                this.update();
              }
            });
          });

          if (option.kind !== 'visual') {
            const note = document.createElement('p');
            note.className = 'text-xs text-subdued';
            note.textContent = this.translations.quoteOnlyNote;
            fieldset.append(note);
          }

          fieldset.append(choices);
          this.optionGroups.append(fieldset);
        });

        if (!this.optionGroups.children.length) {
          this.optionGroups.textContent = this.translations.empty;
        }
      }

      applyCompatibilityRules() {
        const rules = Array.isArray(this.model.compatibilityRules) ? this.model.compatibilityRules : [];
        const disabled = new Set();

        rules.forEach((rule) => {
          const matches = !rule.when || this.state[rule.when.optionId] === rule.when.valueId;

          if (!matches || !Array.isArray(rule.disable)) {
            return;
          }

          rule.disable.forEach((target) => {
            (target.valueIds || []).forEach((valueId) => disabled.add(`${target.optionId}:${valueId}`));
          });
        });

        this.querySelectorAll('input[data-option-id]').forEach((input) => {
          const option = this.model.options.find((item) => item.id === input.dataset.optionId);
          const value = option?.values.find((item) => item.id === input.value);
          input.disabled = value?.eligible !== true || disabled.has(`${input.dataset.optionId}:${input.value}`);
        });

        return disabled;
      }

      selectedValue(option) {
        if (!option) return undefined;

        return option.values.find((value) => value.id === this.state[option.id] && value.eligible === true);
      }

      validateSelection(disabled) {
        const errors = [];

        this.model.options.forEach((option) => {
          const value = this.selectedValue(option);

          if (option.required === true && !value) {
            errors.push(`missing:${option.id}`);
          }

          if (value && disabled.has(`${option.id}:${value.id}`)) {
            errors.push(`incompatible:${option.id}:${value.id}`);
          }
        });

        return errors;
      }

      createPayload(errors) {
        const selections = this.model.options.map((option) => {
          const value = this.selectedValue(option);

          return {
            optionId: option.id,
            sourceOptionId: option.sourceOptionId,
            optionLabel: option.label,
            kind: option.kind,
            viewerEffect: option.viewerEffect,
            valueId: value?.id || null,
            valueLabel: value?.label || null,
            sourceLabel: value?.sourceLabel || value?.label || null,
            sourceValueId: value?.sourceValueId || null,
            quoteTier: value?.quoteTier || null,
            defaultProvenance: this.model.defaultEvidence?.[option.id] || null,
            eligible: value?.eligible === true,
            quoteConfirmation: value?.quoteConfirmation === true
          };
        });

        const compatibilityStatus = this.model.verification?.compatibility || 'unknown';
        const confirmationSelections = selections.filter((selection) => selection.quoteConfirmation).map((selection) => ({ optionId: selection.optionId, valueId: selection.valueId }));
        const confirmationReasons = [];

        if (confirmationSelections.length > 0) {
          confirmationReasons.push('source_quote_tier_or_availability');
        }

        if (compatibilityStatus !== 'verified') {
          confirmationReasons.push('compatibility_not_verified');
        }

        return {
          payloadVersion: '1.1',
          schemaVersion: this.model.schemaVersion,
          catalogVersion: this.model.catalogVersion,
          selectionKey: selections.map((selection) => `${selection.sourceOptionId}:${selection.sourceValueId}`).join('|'),
          product: {
            shopifyProductId: Number(this.dataset.productId),
            handle: this.dataset.productHandle,
            templateSuffix: this.dataset.productTemplate,
            title: this.model.product.title,
            vendor: this.model.product.vendor,
            url: this.model.product.url,
            sourceProductId: this.model.eligibility.sourceProductId,
            fixedFeatures: this.model.product.fixedFeatures
          },
          selections,
          requiresQuoteConfirmation: confirmationReasons.length > 0,
          confirmationReasons,
          confirmationSelections,
          compatibility: {
            ruleCount: this.model.compatibilityRules.length,
            status: this.model.compatibility?.status || 'unspecified',
            evaluated: this.model.compatibilityRules.length > 0,
            passed: this.model.compatibilityRules.length > 0 ? !errors.some((error) => error.startsWith('incompatible:')) : null
          },
          validation: {
            mode: this.model.eligibility.mode,
            exactProductMatch: true,
            catalogValidatedAt: this.model.eligibility.validatedAt,
            policy: this.model.validation,
            passed: errors.length === 0,
            errors
          },
          viewer: this.model.viewer,
          verification: this.model.verification,
          sources: this.model.sources,
          dataGaps: this.model.gaps
        };
      }

      createSummary(payload) {
        return payload.selections
          .filter((selection) => selection.valueLabel !== null)
          .map((selection) => `${selection.optionLabel}: ${selection.valueLabel}`)
          .join('\n');
      }

      updateViewer() {
        const container = this.querySelector('[data-viewer-selections]');

        if (!container) {
          return;
        }

        container.replaceChildren();

        this.model.options.filter((option) => option.kind === 'visual').forEach((option) => {
          const value = this.selectedValue(option);
          const item = document.createElement('div');
          const label = document.createElement('span');
          const selection = document.createElement('strong');

          item.className = 'product-configurator__material';
          label.className = 'text-subdued';
          label.textContent = `${option.label}:`;
          selection.textContent = value?.label || '';

          if (value?.color) {
            const swatch = document.createElement('span');
            swatch.className = 'product-configurator__material-swatch';
            swatch.style.setProperty('--builder-cloth-color', value.color);
            item.append(swatch);
          }

          item.append(label, selection);
          container.append(item);
        });
      }

      updateSummary(payload) {
        this.summary.replaceChildren();

        payload.selections.forEach((selection) => {
          const term = document.createElement('dt');
          const description = document.createElement('dd');
          term.textContent = selection.optionLabel;
          description.textContent = selection.valueLabel;
          this.summary.append(term, description);
        });
      }

      update() {
        const disabled = this.applyCompatibilityRules();
        const errors = this.validateSelection(disabled);

        if ((this.modelViewer || this.model.viewer?.mode === 'layered_preview') && !this.viewerReady) {
          errors.push(this.viewerFailed ? 'viewer_unavailable' : 'viewer_not_ready');
        }

        const payload = this.createPayload(errors);
        const summary = this.createSummary(payload);
        const viewerPending = errors.includes('viewer_not_ready');
        const viewerUnavailable = errors.includes('viewer_unavailable');
        const selectionErrors = errors.filter((error) => !['viewer_not_ready', 'viewer_unavailable'].includes(error));

        this.updateViewer();
        if (this.model.viewer?.mode === 'layered_preview') {
          this.applyLayeredMappings();
        } else {
          void this.applyVisualMappings();
        }
        this.updateSummary(payload);
        this.validationStatus.textContent = viewerPending ? this.translations.modelLoading : (errors.length === 0 ? this.translations.valid : this.translations.invalid);
        this.useButton.disabled = errors.length > 0;
        this.error.hidden = selectionErrors.length === 0 && !viewerUnavailable;

        if (viewerUnavailable) {
          this.error.textContent = this.model.viewer?.mode === 'layered_preview' ? this.translations.previewMappingError : this.translations.modelMappingError;
        } else if (selectionErrors.length > 0) {
          this.error.textContent = this.translations.invalid;
        }

        try {
          sessionStorage.setItem(this.storageKey(), JSON.stringify(this.state));
        } catch (error) {
          this.dataset.storageUnavailable = 'true';
        }

        this.currentConfiguration = { payload, summary };
      }

      useConfiguration() {
        const stored = this.currentConfiguration;

        if (!stored?.payload?.validation?.passed) {
          this.showError(this.translations.invalid);
          return;
        }

        const committedAt = new Date().toISOString();
        const configurationId = globalThis.crypto?.randomUUID?.() || `${this.dataset.productId}-${Date.now()}`;
        const committed = {
          payload: {
            ...stored.payload,
            commit: {
              configurationId,
              committedAt,
              integrity: 'client_generated_untrusted'
            }
          },
          summary: stored.summary
        };
        const payloadBytes = new TextEncoder().encode(JSON.stringify(committed.payload)).length;
        const summaryBytes = new TextEncoder().encode(committed.summary).length;

        if (payloadBytes > 60000 || summaryBytes > 10000) {
          this.showError(this.translations.invalid);
          return;
        }

        window.badlandsCommittedProductConfigurations = window.badlandsCommittedProductConfigurations || new Map();
        window.badlandsCommittedProductConfigurations.set(this.committedKey(), committed);

        this.dispatchEvent(new CustomEvent('product-configurator:saved', {
          bubbles: true,
          detail: committed
        }));
        this.dialog.close();

        const quotePanel = document.getElementById(this.dataset.quotePanelId);

        if (quotePanel) {
          quotePanel.scrollIntoView({ behavior: 'smooth', block: 'start' });
          setTimeout(() => quotePanel.querySelector('input:not([type="hidden"]), textarea, button')?.focus({ preventScroll: true }), 450);
        }
      }

      showError(message) {
        this.error.hidden = false;
        this.error.textContent = message;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-quote-request"] && !Shopify.designMode) return;
  try {
    (() => {
    const formConfigurations = new WeakMap();
    const configurationBlockStart = '[Badlands Builder Configuration]';
    const configurationBlockEnd = '[/Badlands Builder Configuration]';

    const withoutConfigurationBlock = (value) => {
      const text = String(value || '');
      const start = text.indexOf(configurationBlockStart);

      if (start < 0) {
        return text.trim();
      }

      const end = text.indexOf(configurationBlockEnd, start + configurationBlockStart.length);

      if (end < 0) {
        return text.trim();
      }

      return `${text.slice(0, start)}${text.slice(end + configurationBlockEnd.length)}`
        .replace(/\n{3,}/g, '\n\n')
        .trim();
    };

    const messageWithConfiguration = (value, configuration) => {
      const customerMessage = withoutConfigurationBlock(value);
      const configurationBlock = `${configurationBlockStart}\n${configuration.summary}\n${configurationBlockEnd}`;
      return customerMessage ? `${customerMessage}\n\n${configurationBlock}` : configurationBlock;
    };

    const upsertHiddenField = (form, key, name, value) => {
      let field = form.querySelector(`[data-builder-field="${key}"]`);

      if (!field) {
        field = document.createElement('input');
        field.type = 'hidden';
        field.dataset.builderField = key;
        form.append(field);
      }

      field.name = name;
      field.value = value;
    };

    const renderConfigurationSummary = (root, configuration) => {
      const panel = root.closest('.product-quote-request');
      const container = panel?.querySelector('[data-quote-configuration]');
      const summary = container?.querySelector('[data-quote-configuration-summary]');
      const inlineReview = Boolean(panel?.closest('.classic-builder--layout-pilot'));

      if (!container || !summary) {
        return;
      }

      container.toggleAttribute('data-inline-review', inlineReview);
      const rows = configuration.payload.selections.map((selection) => ({
        id: selection.optionId,
        label: selection.optionLabel,
        value: !inlineReview && selection.previewStatus
          ? `${selection.valueLabel} — ${selection.previewStatus}`
          : selection.valueLabel
      }));

      if (inlineReview) {
        const inlineOrder = ['table-size', 'finish', 'pockets', 'cloth', 'sights', 'drawer', 'dining-top'];
        rows.sort((left, right) => inlineOrder.indexOf(left.id) - inlineOrder.indexOf(right.id));
      }

      if (root.dataset.configurationShowFixedFeatures !== 'false') {
        configuration.payload.product.fixedFeatures?.forEach((feature) => rows.push({
          label: feature.label,
          value: feature.id === 'pockets'
            ? `${feature.value} — fixed independently; color confirmed in quote`
            : `${feature.value} — fixed product detail`
        }));
      }

      const currentRows = Array.from(summary.children).reduce((items, node, index, nodes) => {
        if (node.tagName === 'DT' && nodes[index + 1]?.tagName === 'DD') {
          items.push({ id: rows[items.length]?.id, label: node.textContent, value: nodes[index + 1].textContent });
        }
        return items;
      }, []);

      if (JSON.stringify(currentRows) !== JSON.stringify(rows)) {
        const fragment = document.createDocumentFragment();
        rows.forEach((row) => {
          const term = document.createElement('dt');
          const description = document.createElement('dd');
          term.textContent = row.label;
          description.textContent = row.value;
          fragment.append(term, description);
        });
        summary.replaceChildren(fragment);
      }

      container.hidden = false;
    };

    const attachConfigurationToForms = (root, configuration) => {
      const payloadName = root.dataset.configurationFieldName;
      const summaryName = root.dataset.configurationSummaryFieldName;
      const verifiedFormId = root.dataset.verifiedFormId;
      const messageName = root.dataset.configurationMessageFieldName;
      const payloadValue = JSON.stringify(configuration.payload);
      const forms = Array.from(root.querySelectorAll('form')).filter((form) => (
        form.dataset.id === verifiedFormId
        && form.action === `https://app.powerfulform.com/api/front/form/${verifiedFormId}/send`
        && form.querySelector(`textarea[name="${messageName}"]`)
      ));

      forms.forEach((form) => {
        const email = form.querySelector('input[name="email"]');
        const phone = form.querySelector('input[name="phone-1"]');
        if (email) {
          email.setAttribute('inputmode', 'email');
          email.setAttribute('autocomplete', 'email');
        }
        if (phone) {
          phone.setAttribute('inputmode', 'tel');
          phone.setAttribute('autocomplete', 'tel');
        }
        const message = form.querySelector(`textarea[name="${messageName}"]`);
        const inlineReview = root.closest('.product-quote-request')?.querySelector('[data-quote-configuration][data-inline-review]');
        const submitArea = form.querySelector('.wizard__footer') || form.querySelector('button[type="submit"]');
        formConfigurations.set(form, configuration);
        upsertHiddenField(form, 'json', payloadName, payloadValue);
        upsertHiddenField(form, 'summary', summaryName, configuration.summary);
        message.value = withoutConfigurationBlock(message.value);

        if (inlineReview && submitArea && submitArea.previousElementSibling !== inlineReview) {
          submitArea.insertAdjacentElement('beforebegin', inlineReview);
        }

        if (form.dataset.builderFormdataBound === 'true') {
          return;
        }

        form.dataset.builderFormdataBound = 'true';
        form.addEventListener('formdata', (event) => {
          const current = formConfigurations.get(form);

          if (!current?.payload?.validation?.passed) {
            return;
          }

          event.formData.set(payloadName, JSON.stringify(current.payload));
          event.formData.set(summaryName, current.summary);
          event.formData.set(messageName, messageWithConfiguration(event.formData.get(messageName), current));
        });
      });

      const status = root.closest('.product-quote-request')?.querySelector('[data-quote-configuration-status]');

      if (status) {
        const nextStatus = forms.length > 0 ? root.dataset.configurationAttachedLabel : root.dataset.configurationPendingLabel;

        if (status.textContent !== nextStatus) {
          status.textContent = nextStatus;
        }
      }

      return forms.length > 0;
    };

    const syncConfiguration = (root, configuration) => {
      if (
        !configuration?.payload?.validation?.passed
        || String(configuration.payload.product.shopifyProductId) !== root.dataset.productId
        || configuration.payload.product.handle !== root.dataset.productHandle
      ) {
        return;
      }

      renderConfigurationSummary(root, configuration);
      attachConfigurationToForms(root, configuration);
    };

    const syncStoredConfiguration = (root) => {
      const key = `${root.dataset.productId}:${root.dataset.productHandle}`;
      const configuration = window.badlandsCommittedProductConfigurations?.get(key);

      if (configuration) {
        syncConfiguration(root, configuration);
      }
    };

    const setSubmitLabel = (root) => {
      const label = root.getAttribute('data-submit-label');

      if (!label) {
        return;
      }

      root.querySelectorAll('button[type="submit"], .wizard__submit').forEach((button) => {
        const currentText = button.textContent.replace(/\s+/g, ' ').trim();

        if (button.dataset.quoteSubmitLabel === label && currentText === label) {
          return;
        }

        const spinner = button.querySelector('.spinner');

        button.textContent = '';

        if (spinner) {
          button.appendChild(spinner);
        }

        button.appendChild(document.createTextNode(label));
        button.dataset.quoteSubmitLabel = label;
        button.dataset.submitText = `<span class="spinner"></span>${label}`;
        button.setAttribute('aria-label', label);
      });
    };

    const positionInlineSubmit = (root) => {
      const builder = root.closest('.classic-builder--layout-pilot');
      const card = builder?.querySelector('[data-classic-quote-workspace], [data-presidential-quote-workspace]');
      const review = root.closest('.product-quote-request')?.querySelector('[data-quote-configuration][data-inline-review]');
      const footer = root.querySelector('.wizard__footer');
      const button = footer?.querySelector('button[type="submit"]');

      if (!footer) {
        return;
      }

      if (!builder || !card || !review || !button || !window.matchMedia('(min-width: 900px)').matches) {
        if (footer.style.getPropertyValue('--quote-submit-offset-y') !== '0px') {
          footer.style.setProperty('--quote-submit-offset-y', '0px');
        }

        return;
      }

      const currentOffset = Number.parseFloat(footer.style.getPropertyValue('--quote-submit-offset-y')) || 0;
      const buttonRect = button.getBoundingClientRect();
      const reviewRect = review.getBoundingClientRect();
      const cardRect = card.getBoundingClientRect();
      const baseButtonCenter = buttonRect.top + (buttonRect.height / 2) - currentOffset;
      const targetCenter = reviewRect.bottom + ((cardRect.bottom - reviewRect.bottom) / 2);
      const nextOffset = Math.max(0, targetCenter - baseButtonCenter);
      const nextValue = `${Math.round(nextOffset * 10) / 10}px`;

      if (footer.style.getPropertyValue('--quote-submit-offset-y') !== nextValue) {
        footer.style.setProperty('--quote-submit-offset-y', nextValue);
      }
    };

    const observeInlineSubmitPosition = (root) => {
      if (root.dataset.quoteSubmitPositionObserver === 'true' || !('ResizeObserver' in window)) {
        return;
      }

      const builder = root.closest('.classic-builder--layout-pilot');
      const card = builder?.querySelector('[data-classic-quote-workspace], [data-presidential-quote-workspace]');
      const review = root.closest('.product-quote-request')?.querySelector('[data-quote-configuration][data-inline-review]');

      if (!card || !review) {
        return;
      }

      let positionFrame;
      const positionObserver = new ResizeObserver(() => {
        cancelAnimationFrame(positionFrame);
        positionFrame = requestAnimationFrame(() => positionInlineSubmit(root));
      });

      positionObserver.observe(card);
      positionObserver.observe(root);
      positionObserver.observe(review);
      root.dataset.quoteSubmitPositionObserver = 'true';
    };

    const setShowroomLinks = (root) => {
      const panel = root.closest('.product-quote-request');

      if (!panel) {
        return;
      }

      panel.querySelectorAll('a[href="/pages/showroom"]').forEach((link) => {
        link.setAttribute('href', '/pages/service-area');
      });
    };

    const isVisible = (element) => {
      if (!element) {
        return false;
      }

      const style = window.getComputedStyle(element);

      return style.display !== 'none' && style.visibility !== 'hidden';
    };

    const hasSuccessMessage = (root) => {
      return Array.from(root.querySelectorAll('.message.success, .wizard__congrats-message')).some((message) => {
        const text = message.textContent.replace(/\s+/g, ' ').trim().toLowerCase();

        return isVisible(message) && /thank|success|received|submitted|sent|getting in touch/.test(text);
      });
    };

    const setSuccessState = (root) => {
      const isSubmitted = hasSuccessMessage(root);
      const successMessage = root.querySelector('.product-quote-request__success');
      const panel = root.closest('.product-quote-request');

      root.classList.toggle('is-submitted', isSubmitted);
      panel?.classList.toggle('product-quote-request--submitted', isSubmitted);

      if (!successMessage) {
        return;
      }

      successMessage.hidden = !isSubmitted;

      if (isSubmitted && successMessage.dataset.quoteSuccessFocused !== 'true') {
        successMessage.dataset.quoteSuccessFocused = 'true';

        requestAnimationFrame(() => {
          successMessage.focus({ preventScroll: true });
        });
      }
    };

    const mountPoolTableBuilderQuote = (root) => {
      const panel = root.closest('.product-quote-request--classic-builder, .product-quote-request--pool-table-builder');

      if (!panel?.id) {
        return;
      }

      const builder = [...document.querySelectorAll('classic-builder-prototype[data-quote-panel-id], pool-table-visual-builder[data-quote-panel-id], pool-table-quote-builder[data-quote-panel-id], presidential-fixed-builder[data-quote-panel-id]')]
        .find((candidate) => candidate.dataset.quotePanelId === panel.id);
      const slot = builder?.querySelector('[data-classic-quote-slot], [data-pool-table-quote-slot], [data-presidential-quote-slot]');

      if (!slot || panel.parentElement === slot) {
        return;
      }

      const originalContainer = panel.parentElement;
      slot.append(panel);
      panel.dataset.poolTableBuilderMounted = 'true';

      if (originalContainer && originalContainer.childElementCount === 0) {
        originalContainer.hidden = true;
      }
    };

    const positionPoolTableProductDetails = (root) => {
      const builder = root.closest('.classic-builder--layout-pilot');
      const details = builder?.querySelector('.classic-builder__product-details-slot');
      const quote = builder?.querySelector('.classic-builder__quote-workspace');

      if (!details || !quote || details.parentElement !== quote.parentElement) {
        return;
      }

      // Move only supporting details so the mounted form and entered values stay in place.
      if (window.matchMedia('(max-width: 899px)').matches) {
        if (quote.nextElementSibling !== details) {
          quote.after(details);
        }
      } else if (details.nextElementSibling !== quote) {
        quote.before(details);
      }
    };

    const bindMobileStageScroll = (root) => {
      const stage = root.closest('.classic-builder--layout-pilot')?.querySelector('.classic-builder__stage');

      if (!stage || stage.dataset.mobileStageScroll === 'true') {
        return;
      }

      const mobile = window.matchMedia('(max-width: 899px) and (pointer: coarse)');
      let gesture;
      const isPinned = () => stage.getBoundingClientRect().top <= (Number.parseFloat(getComputedStyle(stage).top) || 0) + 1;

      stage.addEventListener('touchstart', (event) => {
        gesture = mobile.matches && event.touches.length === 1 ? {
          id: event.touches[0].identifier,
          x: event.touches[0].clientX,
          y: event.touches[0].clientY,
          pinned: isPinned()
        } : null;
      }, { passive: true });

      stage.addEventListener('touchmove', (event) => {
        if (!gesture || !mobile.matches || event.touches.length !== 1) {
          gesture = null;
          return;
        }

        const touch = [...event.touches].find((item) => item.identifier === gesture.id);
        if (!touch) return;

        const deltaX = gesture.x - touch.clientX;
        const deltaY = gesture.y - touch.clientY;
        gesture.x = touch.clientX;
        gesture.y = touch.clientY;

        if (Math.abs(deltaY) < Math.abs(deltaX)) return;
        if (event.cancelable) event.preventDefault();
        if (gesture.pinned && deltaY >= 0) return;

        // A swipe on the image can bring it to the header, then stops there.
        const stickyTop = Number.parseFloat(getComputedStyle(stage).top) || 0;
        const remaining = Math.max(0, stage.getBoundingClientRect().top - stickyTop);
        window.scrollBy({ top: deltaY > 0 ? Math.min(deltaY, remaining) : deltaY, behavior: 'instant' });
        gesture.pinned = isPinned();
      }, { passive: false });

      const endGesture = () => { gesture = null; };
      stage.addEventListener('touchend', endGesture, { passive: true });
      stage.addEventListener('touchcancel', endGesture, { passive: true });
      stage.dataset.mobileStageScroll = 'true';
    };

    const initQuoteForms = () => {
      document.querySelectorAll('.product-quote-request__app-form').forEach((root) => {
        mountPoolTableBuilderQuote(root);
        positionPoolTableProductDetails(root);
        bindMobileStageScroll(root);
        setShowroomLinks(root);
        setSubmitLabel(root);
        setSuccessState(root);
        syncStoredConfiguration(root);
        positionInlineSubmit(root);
        observeInlineSubmitPosition(root);

        requestAnimationFrame(() => requestAnimationFrame(() => positionInlineSubmit(root)));
        window.setTimeout(() => positionInlineSubmit(root), 750);

        if (root.dataset.quoteSubmitObserver === 'true') {
          return;
        }

        root.dataset.quoteSubmitObserver = 'true';

        new MutationObserver(() => {
          setShowroomLinks(root);
          setSubmitLabel(root);
          setSuccessState(root);
          syncStoredConfiguration(root);
          observeInlineSubmitPosition(root);
          positionInlineSubmit(root);
        }).observe(root, { childList: true, subtree: true });
      });
    };

    document.addEventListener('product-configurator:saved', (event) => {
      document.querySelectorAll('.product-quote-request__app-form').forEach((root) => {
        syncConfiguration(root, event.detail);
        positionInlineSubmit(root);
      });
    });

    let quoteSubmitResizeFrame;
    window.addEventListener('resize', () => {
      cancelAnimationFrame(quoteSubmitResizeFrame);
      quoteSubmitResizeFrame = requestAnimationFrame(() => {
        document.querySelectorAll('.product-quote-request__app-form').forEach(positionPoolTableProductDetails);
        document.querySelectorAll('.product-quote-request__app-form').forEach(positionInlineSubmit);
      });
    }, { passive: true });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initQuoteForms, { once: true });
    } else {
      initQuoteForms();
    }

    document.addEventListener('shopify:section:load', initQuoteForms);
  })();
  } catch(e) { console.error(e); }
})();

})();
